<div class="dqf-review page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-testid="back-arrow-icon">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text">DQF for {{ carrierCompanyName }}</div>
  </div>

  <div>
    <div class="review">
      <div>
        <div   class="review-header">
          <div ><button class="font-family" (click)="onEdit()" data-testid="dqf-declaration-edit">Edit</button></div>
          <div class="profile">
            <img [src]="profilePicture">
          </div>

          <div  class="sign-in">
            <button class="font-family" (click)="openSignature()" data-test="signin-button" data-testid="signin-button">Sign</button>
          </div>
        </div>
      </div>
      <div class="review-info" >
        @for (info of declarationInfo; track info) {
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header [collapsedHeight]="customCollapsedHeight"
                [expandedHeight]="customCollapsedHeight" class="expansion-header" class="font-family">
                <mat-panel-title>
                  {{info.heading}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="info-content" [innerHTML]="info.value">
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>
  </div>
</div>